"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.CascadingGrid = void 0;
var react_1 = __importStar(require("react"));
var ramda_1 = require("ramda");
var List_1 = require("../List");
var CASCADING_ATTRIBUTE = 'data-cascading-column';
// Set width of new dom node or reset all width if layout has changed
var updateSizes = function (node, _a, reset) {
    var columns = _a.columns, rowGap = _a.rowGap, rest = __rest(_a, ["columns", "rowGap"]);
    var multiColumnLayout = columns > 1;
    node.childNodes.forEach(function (element) {
        var elementDom = element;
        if (reset) {
            elementDom.style.width = '';
        }
        if (multiColumnLayout) {
            elementDom.style.width = "calc(" + 100 / columns + "% - " + (rowGap * (columns - 1)) / columns + "px)";
        }
        if (!elementDom.hasAttribute(CASCADING_ATTRIBUTE) || reset) {
            elementDom.style.visibility = 'hidden';
        }
    });
    window.requestAnimationFrame(function () {
        return updatePositions(node, __assign({ columns: columns, rowGap: rowGap }, rest), reset);
    });
};
// Set position of each dom node in absolute
var updatePositions = function (node, _a, reset) {
    var columns = _a.columns, rowGap = _a.rowGap, columnGap = _a.columnGap;
    var columnHeights = ramda_1.times(function () { return 0; }, columns);
    var multiColumnLayout = columns > 1;
    node.childNodes.forEach(function (element, index) {
        var elementDom = element;
        if (reset) {
            elementDom.style.position = '';
            elementDom.style.top = '';
            elementDom.style.left = '';
            elementDom.style.marginTop = '';
        }
        var height = elementDom.getBoundingClientRect().height;
        /* istanbul ignore next */
        elementDom.style.visibility = height > 0 ? 'visible' : 'hidden';
        if (!multiColumnLayout) {
            elementDom.style.marginTop = index > 0 ? columnGap + "px" : '';
        }
        else {
            var columnTarget = +(elementDom.getAttribute(CASCADING_ATTRIBUTE) || 0);
            if (!elementDom.hasAttribute(CASCADING_ATTRIBUTE) || reset) {
                columnTarget = columnHeights.indexOf(Math.min.apply(null, columnHeights));
                elementDom.setAttribute(CASCADING_ATTRIBUTE, String(columnTarget));
            }
            elementDom.style.position = 'absolute';
            elementDom.style.top = columnHeights[columnTarget] + "px";
            elementDom.style.left = "calc(" + (columnTarget * 100) / columns + "% - " + (columnTarget * (columns - 1) * rowGap) / columns + "px + " + columnTarget * rowGap + "px";
            columnHeights[columnTarget] += height + columnGap;
        }
    });
    node.style.height = !multiColumnLayout
        ? ''
        : Math.max.apply(null, columnHeights) - columnGap + "px";
};
var CascadingGrid = function (_a) {
    var _b = _a.columns, columns = _b === void 0 ? 3 : _b, _c = _a.rowGap, rowGap = _c === void 0 ? 25 : _c, _d = _a.columnGap, columnGap = _d === void 0 ? 25 : _d, className = _a.className, children = _a.children, rest = __rest(_a, ["columns", "rowGap", "columnGap", "className", "children"]);
    var containerRef = react_1.useRef();
    react_1.useEffect(function () {
        window.requestAnimationFrame(function () {
            containerRef.current &&
                updateSizes(containerRef.current, { columns: columns, rowGap: rowGap, columnGap: columnGap }, true);
        });
    }, [columns, react_1.Children.count(children)]);
    react_1.useEffect(function () {
        window.requestAnimationFrame(function () {
            containerRef.current &&
                updateSizes(containerRef.current, { columns: columns, rowGap: rowGap, columnGap: columnGap }, false);
        });
    }, [rowGap, columnGap]);
    return (react_1["default"].createElement(List_1.List, __assign({ className: ['cascading-grid', className], innerRef: containerRef, style: { position: 'relative' } }, rest), children));
};
exports.CascadingGrid = CascadingGrid;
//# sourceMappingURL=CascadingGrid.js.map